import { gql } from "apollo-boost"
import { updateVehicle, updateVehicleVariables } from "../generated/updateVehicle"

export const UPDATE_VEHICLE_MUTATION = gql`
  mutation updateVehicle(
    $vehicleId: ID!
    $wasteScannerId: ID!
    $rfidReader: ID
    $geoCeptImei: ID
    $rfidReadingToMaterialAnalysisOffset: MinMaxInput
    $geoCeptToMaterialAnalysisOffset: MinMaxInput
    $imageLimit: Int
  ) {
    updateVehicle(
      vehicleId: $vehicleId
      wasteScannerId: $wasteScannerId
      rfidReader: $rfidReader
      geoCeptImei: $geoCeptImei
      rfidReadingToMaterialAnalysisOffset: $rfidReadingToMaterialAnalysisOffset
      geoCeptToMaterialAnalysisOffset: $geoCeptToMaterialAnalysisOffset
      imageLimit: $imageLimit
    ) {
      id
    }
  }
`

export type UpdateVehicleResult = updateVehicle
export type UpdateVehicleVariables = updateVehicleVariables
